import { ICarrier } from './carriers'
import { IMotorCarrier } from './entity'
import { SortFieldType, SortOrderType } from './hooks'

export enum DriverStatusType {
  active = 'active',
  inactive = 'inactive',
}

export interface DriverSettingsType {
  smsStatusUpdatesEnabled: boolean
  suppressSmsStatusUpdatesOptIn?: boolean
}

export interface IDriver {
  motorCarrierId?: number
  uuid?: string
  id?: string
  name?: string
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  cellPhone?: string
  mcNumber?: number
  motorCarrier?: ICarrier
  entityId?: string
  motorCarrierLegalName?: string
  updatedAt?: string
  status?: DriverStatusType
  settings?: DriverSettingsType
  smsStatusEnabledForShipment?: boolean
  /* if cellPhoneIsTwilioSubscribed is false,
   * takes precedence over SmsStatusUpdatesEnabled
   */
  cellPhoneIsTwilioSubscribed?: Readonly<boolean>
  transfixUserId?: number
  motorCarriers?: IMotorCarrier[]
}

export interface ICreateDriverState {
  fetching: boolean
  error?: string
  driver?: IDriver
}

export interface ICreateDriverResponse {
  driver: IDriver
}

export interface IGetDriversResponse {
  drivers: IDriver[]
}

export interface IGetDriversFilters {
  mcNumber?: number
  motorCarrierId?: number | string
  search?: string
}

export interface IGetDriversParams {
  sortField?: SortFieldType
  sortOrder?: SortOrderType
  filters?: IGetDriversFilters
}
